let giftingModal = document.getElementById("giftingmodal");


async function addGiftingToCart(prodid, addmessage='',chosendate='') {
    cart = document.querySelector('cart-drawer');

    let sectionstoRender = cart.getSectionsToRender().map((section) => section.id);
    
    let formData = {
        'items': [
            {
                'id': prodid,
                'quantity': 1
            }
        ],
        'sections': sectionstoRender.join(','),
        'sections_url': window.location.pathname
    };

    // if (addmessage) {
    //     formData['attributes'] = { 'message': addmessage };
    //     if (chosendate !== '') {
    //         formData['attributes']['chosendate'] = chosendate;
    //     }
    // }
    formData['attributes'] = { 'message': addmessage, 'chosendate': chosendate };
    
    cart.setActiveElement(document.activeElement);

    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
    })
    .then((response) => {
        if (!response.ok) {
            throw new Error('Failed to add item to cart');
        }

        return response.json();
    })
    .then((data) => {


        cart.getSectionsToRender().forEach((section) => {
            let sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
            let selector = section.selector ? section.selector : '.shopify-section';
            sectionElement.innerHTML = new DOMParser().parseFromString(data.sections[section.id], 'text/html').querySelector(selector).innerHTML;
        });
            
        setTimeout(() => {
            cart.querySelector('#CartDrawer-Overlay').addEventListener('click', cart.close.bind(cart));
            cart.open();
        });

        publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'gifting-form',
            productVariantId: prodid,
            cartData: data,
        });


        if (typeof window.disableGifting === 'function') {
            window.disableGifting();
        }
    })
    .catch((error) => {
        console.error('Error:', error);
    }).finally(() => {
        if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
    });

}

if (giftingModal) {

    let giftingModalContainer = giftingModal.querySelector(".modal-container");
    let modalClose = giftingModal.querySelector(".close");
    
    let blankradio = document.getElementById("blankradio");
    let printedradio = document.getElementById("printedradio");
    let handradio = document.getElementById("handradio");

    let blankID = giftingModal.getAttribute('data-blank');
    let printedID = giftingModal.getAttribute('data-printed');
    let handID = giftingModal.getAttribute('data-hand');
    
    let giftingdate = document.getElementById("giftingdate");
    let deliverystd = document.getElementById("deliverystd");
    let deliverychosen = document.getElementById("deliverychosen");

    
    /* open gifting */
    let openGifting = function() {
        document.body.classList.add("overflow-hidden"); 
        giftingModal.showModal();
        if (giftingModal.querySelector('input')) {
            giftingModal.querySelector('input').focus();
        }
    }

    // listen to all click events and only act on the ones that have the class 'button--gifting'
    document.addEventListener('click', function (event) {
        if (event.target.classList.contains('button--gifting')) {
            event.stopPropagation();
            event.preventDefault();
            openGifting();
            return false;
        }
    });
    
    

    /* close gifting */
    let closeGifting = function() {
        document.body.classList.remove("overflow-hidden");
        giftingModal.close(); 
        giftingModalContainer.setAttribute('data-step', '1');
        handradio.checked = true;
        giftingModalContainer.setAttribute('data-card', "Hand Written");
        message.value = "";
        giftingModalContainer.setAttribute('data-message', "false");
        giftingdate.value = "";
        deliverystd.checked = false;
        deliverychosen.checked = false;

    }
    modalClose.addEventListener("click", closeGifting);
    giftingModal.addEventListener("click", closeGifting);
    giftingModalContainer.addEventListener("click", (event) => event.stopPropagation());


    /* step 1 related actions */
    blankradio.addEventListener('change', function() {
        if (this.checked) {
            giftingModalContainer.setAttribute('data-card', this.value);
        }
    });
    printedradio.addEventListener('change', function() {
        if (this.checked) {
            giftingModalContainer.setAttribute('data-card', this.value);
        }
    });
    handradio.addEventListener('change', function() {
        if (this.checked) {
            giftingModalContainer.setAttribute('data-card', this.value);
        }
    });
    function processCardSelection() {

        if (blankradio.checked) {
            addGiftingToCart(blankID)
            closeGifting();
            return;
        }
        if (printedradio.checked) {
            giftingModalContainer.setAttribute('data-card', "Printed");
        }
        if (handradio.checked) {
            giftingModalContainer.setAttribute('data-card', "Hand Written");
        }

        giftingModalContainer.setAttribute('data-step', '2');

        // set min date on date field: giftingdate
        // blank = 2 days from now, printed = 2 days from now, hand = 5 days from now
        let today = new Date();
        let minDate = new Date(today);
        let maxDate = new Date(today);
        minDate.setDate(today.getDate() + 2);
        maxDate.setDate(today.getDate() + 180);
        if (handradio.checked) {
            minDate.setDate(today.getDate() + 5);
        }
        giftingdate.setAttribute('min', minDate.toISOString().split('T')[0]);
        giftingdate.setAttribute('max', maxDate.toISOString().split('T')[0]);

    }


    /* step 2 related actions */
    let message = document.getElementById("giftingmessage");
    message.addEventListener('input', function() {
        let maxChars = parseInt(this.parentNode.getAttribute('data-max'));
        let curChars = this.value.length;
        let charsLeft = maxChars - curChars;

        if (charsLeft < 0) {
            this.value = this.value.substring(0, maxChars);
            curChars = this.value.length;
            charsLeft = 0;
        }

        if (curChars == 0) {
            giftingModalContainer.setAttribute('data-message', "false");
        } else {
            giftingModalContainer.setAttribute('data-message', "true");
        }

        this.parentNode.setAttribute("data-notice", curChars + "/" + maxChars + " characters");
    });
    function processMessage() {
        let chosenID = printedID;
        if (handradio.checked) {
            chosenID = handID;
        }
        addGiftingToCart(chosenID, message.value, '')
        closeGifting();
        //giftingModalContainer.setAttribute('data-step', '3');
    }


    /* step 3 related actions */
    giftingdate.addEventListener('change', function() {
        if (this.value) {
            let allowedDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
            let selectedDate = new Date(this.value);
            let selectedDay = selectedDate.toLocaleDateString('en-US', { weekday: 'long' });
            if (!allowedDays.includes(selectedDay)) {
                giftingdate.parentNode.classList.add('weekdays');
                giftingModalContainer.setAttribute('data-date', "false");
                return;
            }
            giftingdate.parentNode.classList.remove('weekdays');
            giftingdate.parentNode.classList.remove('invalid');
            giftingModalContainer.setAttribute('data-date', "true");
            deliverychosen.checked = true;
        } else {
            giftingModalContainer.setAttribute('data-date', "false");
        }
    });
    deliverystd.addEventListener('change', function() {
        if (this.checked) {
            giftingModalContainer.setAttribute('data-date', "true");
            giftingdate.value = "";
            giftingdate.parentNode.classList.remove('weekdays');
            giftingdate.parentNode.classList.remove('invalid');
        }
    });
    function processDate() {
        let chosenID = printedID;
        if (handradio.checked) {
            chosenID = handID;
        }
        if (deliverystd.checked) {
            console.log("this route");
            addGiftingToCart(chosenID, message.value)
            closeGifting();
            return;
        }
        addGiftingToCart(chosenID, message.value, giftingdate.value)
        closeGifting();
    }


    /* go to next step */
    let nextButtons = giftingModal.querySelectorAll('.complete-step');
    if (nextButtons) {
        nextButtons.forEach(function(nextButton) {
            nextButton.addEventListener('click', function (e) {
                e.stopPropagation();
                e.preventDefault();
                
                let currentStep = this.getAttribute('data-step');

                if (currentStep == '1') {
                    processCardSelection();
                }
                if (currentStep == '2') {
                    processMessage();
                }
                if (currentStep == '3') {
                    processDate();
                }

                return false;
            });
        });
    }

    /* go to previous step */
    let backButton = giftingModal.querySelector('.modal-header .back');
    if (backButton) {
        backButton.addEventListener('click', function (e) {
            e.stopPropagation();
            e.preventDefault();
            let currentStep = giftingModalContainer.getAttribute('data-step');
            if (currentStep == '2') {
                giftingModalContainer.setAttribute('data-step', '1');
            }
            if (currentStep == '3') {
                giftingModalContainer.setAttribute('data-step', '2');
            }
            return false;
        });
    }

    /* enable gifting */
    if(typeof window.enableGifting === 'function') {
        window.enableGiftingLoad();
    }

    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.source === 'gifting-form') {
            return;
        }
        fetch(window.Shopify.routes.root + 'cart.js', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        }).then((response) => {
            if (!response.ok) {
                throw new Error('Failed to get cart');
            }
            return response.json();
        }).then((data) => {

            let hasGifted = false;
            if (data.items) {
                data.items.forEach((item) => {
                    if (item.variant_id == blankID || item.variant_id == printedID || item.variant_id == handID) {
                        // hasGifted = item.variant_id;
                        hasGifted = true;
                    }
                });
            }
            if (data.item_count > 0 && hasGifted === false) {
                if (typeof window.enableGifting === 'function') {
                    window.enableGifting();
                }
            } else {
                if (typeof window.disableGifting === 'function') {
                    window.disableGifting();
                }
            }
            if (data.item_count == 1 && hasGifted === true) {
                if (typeof window.disableGifting === 'function') {
                    window.disableCheckout();
                }
            } else {
                if (typeof window.enableCheckout === 'function') {
                    window.enableCheckout();
                }
            }
        }).catch((error) => {
            console.error('Error:', error);
        });
    });
}
